export function formatFen(fen: number): string {
  if (!Number.isSafeInteger(fen)) {
    throw new Error('fen must be a safe integer')
  }
  return `¥${(fen / 100).toFixed(2)}`
}
